import React, { useState } from 'react';
import Card from '../../../ui/Card';
import Tabs from '../../../ui/Tabs/Tabs';
import Icon from '../../../ui/Icon';
import EmptyState from '../../../ui/EmptyState';
import { ICONS } from '../../../ui/icon-map';
import { usePermissions } from '../../../hooks/usePermissions';
import { PERMISSIONS } from '../../../constants/permissions';
import CollectionsDay13 from './CollectionsDay13';
import RefundsPanel from './RefundsPanel';

// The Reminder tool of the Operations Portal: two engine-built reports about the
// airport deposits. The old "13 days from a reference date" list (Database / Upload
// modes, Dubai / Oman e-mail) was retired on 22 Sep 2026 - the day-13 collections
// report replaced it, and Oman never used it.
const Reminder = () => {
    const { hasPermission } = usePermissions();
    // each tab its own permission (permissions phase 3, 4 Oct 2026); the first one the user holds opens
    const items = [
        ...(hasPermission('ops_collections_view')
            ? [{ id: 'collections', label: 'Collections (day 13)', icon: <Icon glyph={ICONS.wallet} size="sm" /> }]
            : []),
        ...(hasPermission(PERMISSIONS.ops_refunds)
            ? [{ id: 'refunds', label: 'Refunds (30 days)', icon: <Icon glyph={ICONS.refresh} size="sm" /> }]
            : []),
    ];
    const [picked, setMode] = useState(null);   // 'collections' | 'refunds'
    const mode = items.some((t) => t.id === picked) ? picked : items[0]?.id;

    if (!mode) {
        return (
            <EmptyState icon={ICONS.lock} title="No Reminder report for this role"
                description="Collections and Refunds each need their own permission." />
        );
    }

    return (
        <Card padding="none">
            <div className="px-4 pt-3 border-b border-gray-200">
                <Tabs items={items} value={mode} onChange={setMode} label="Reminder reports" idPrefix="reminder" />
            </div>
            <div className="p-4" role="tabpanel" id={`reminder-panel-${mode}`} aria-labelledby={`reminder-${mode}`}>
                {mode === 'refunds' ? <RefundsPanel /> : <CollectionsDay13 />}
            </div>
        </Card>
    );
};

export default Reminder;
